// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const woolBale = defineModel({
  id: "wool-bale",
  batchId: "future",
  name: "Wool bale",
  tags: ["scenery","wool","bale","low-poly","age-of-mcp","future"],
  summary: "A bale of raw wool — spun into cloth, felt and padding.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.36,
  parts: () => [
      { geometry: new THREE.SphereGeometry(0.26, 8, 6), color: "#e4dfd2", position: [0, 0.23, 0], scale: [1.15, 0.85, 1] },
      { geometry: new THREE.SphereGeometry(0.18, 7, 5), color: "#d6d1c2", position: [-0.04, 0.35, 0.02], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.BoxGeometry(0.62, 0.04, 0.04), color: "#8a6a3a", position: [0, 0.23, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.56), color: "#8a6a3a", position: [0, 0.23, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.46, 0.04), color: "#8a6a3a", position: [0, 0.23, 0.28] },
    ],
  animations: [],
});
